import { useTranslate } from 'react-polyglot';

import { Button } from '@genially/design-system';

import { useHostGameContext } from '../../../../HostGame.context';
import { useOpenFinishGameModal } from '../../../../hooks/useOpenFinishGameModal';

export const EndSessionButton = () => {
  const t = useTranslate();
  const { openFinishGameModal } = useOpenFinishGameModal();

  const { settingsSidebar } = useHostGameContext();

  const handleClick = () => {
    settingsSidebar.close();
    openFinishGameModal();
  };

  return (
    <Button variant={Button.Variant.DANGER} width={'100%'} onClick={handleClick}>
      {t('__new.play.shared.closeSession')}
    </Button>
  );
};
